import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import { Lesson } from './components/Lesson/Lesson';
import { Day } from './components/Day';
import { Navigation } from './components/nav/Navigation';
import { NavigationDays } from './components/nav/NavigationDays';
import { NavigationLessons } from './components/nav/NavigationLessons';
import { Contacts } from './components/Contacts/Contacts';
import { Header } from './components/Header/Header';
import { GradeSelection } from './components/GradeSelection/GradeSelection';
import { ROUTES, DAY_COUNTS, SUBJECT_ROUTES } from './constants/routes';

import './App.css';

const HomePage: React.FC = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '3rem',
    padding: '3rem 1rem',
    maxWidth: '1200px',
    width: '100%',
  }}>
    <h1 style={{
      fontSize: 'clamp(2.5rem, 6vw, 3.5rem)',
      fontWeight: 'bold',
      color: '#66b3ff',
      textAlign: 'center',
      lineHeight: '1.3',
      marginBottom: '1rem',
    }}>
      Ласкаво просимо!
    </h1>
    <p style={{
      fontSize: 'clamp(1.15rem, 2.5vw, 1.5rem)',
      textAlign: 'center',
      lineHeight: '1.9',
      maxWidth: '800px',
      color: '#ffffff',
    }}>
      Центр військово-патріотичного виховання та допризовної підготовки учнівської молоді
    </p>
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '2rem',
      width: '100%',
      maxWidth: '900px',
      marginTop: '2rem',
    }}>
      <Link
        to={ROUTES.GRADE_10}
        style={{
          padding: '2.75rem 2.25rem',
          background: 'linear-gradient(135deg, #0057B8 0%, #FFD700 100%)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '16px',
          fontWeight: '700',
          fontSize: '1.75rem',
          border: '2px solid rgba(255, 215, 0, 0.3)',
          transition: 'all 0.3s ease',
          boxShadow: '0 8px 20px rgba(255, 215, 0, 0.3)',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-8px)';
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(255, 215, 0, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 215, 0, 0.3)';
        }}
      >
        10 клас
      </Link>
      <Link
        to={ROUTES.GRADE_11}
        style={{
          padding: '2.75rem 2.25rem',
          background: 'linear-gradient(135deg, #0057B8 0%, #FFD700 100%)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '16px',
          fontWeight: '700',
          fontSize: '1.75rem',
          border: '2px solid rgba(255, 215, 0, 0.3)',
          transition: 'all 0.3s ease',
          boxShadow: '0 8px 20px rgba(255, 215, 0, 0.3)',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-8px)';
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(255, 215, 0, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 215, 0, 0.3)';
        }}
      >
        11 клас
      </Link>
    </div>
  </div>
);

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Navigation />
      <div className="App">
        <Routes>
          <Route path={ROUTES.HOME} element={<HomePage />} />

          {/* Grade Selection Routes */}
          <Route
            path={ROUTES.GRADE_10}
            element={<GradeSelection grade={10} basePath={ROUTES.GRADE_10} />}
          />
          <Route
            path={ROUTES.GRADE_11}
            element={<GradeSelection grade={11} basePath={ROUTES.GRADE_11} />}
          />

          {/* Grade 10 - National Defence */}
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}`}
            element={
              <>
                <NavigationDays numOfDays={DAY_COUNTS.GRADE_10} />
                10 клас (група юнаків)
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}/:dayNumber`}
            element={
              <>
                <NavigationLessons />
                <Day>10 клас (група юнаків)</Day>
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}/:dayNumber/lessons/:numOfLesson`}
            element={<Lesson />}
          />

          {/* Grade 10 - Medicine */}
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.MEDICINE}`}
            element={
              <>
                <NavigationDays numOfDays={DAY_COUNTS.GRADE_10} />
                10 клас (група дівчат)
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.MEDICINE}/:dayNumber`}
            element={
              <>
                <NavigationLessons />
                <Day>10 клас (група дівчат)</Day>
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_10}/${SUBJECT_ROUTES.MEDICINE}/:dayNumber/lessons/:numOfLesson`}
            element={<Lesson />}
          />

          {/* Grade 11 - National Defence */}
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}`}
            element={
              <>
                <NavigationDays numOfDays={DAY_COUNTS.GRADE_11} />
                11 клас (група юнаків)
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}/:dayNumber`}
            element={
              <>
                <NavigationLessons />
                <Day>11 клас (група юнаків)</Day>
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}/:dayNumber/lessons/:numOfLesson`}
            element={<Lesson />}
          />

          {/* Grade 11 - Medicine */}
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.MEDICINE}`}
            element={
              <>
                <NavigationDays numOfDays={DAY_COUNTS.GRADE_11} />
                11 клас (група дівчат)
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.MEDICINE}/:dayNumber`}
            element={
              <>
                <NavigationLessons />
                <Day>11 клас (група дівчат)</Day>
              </>
            }
          />
          <Route
            path={`${ROUTES.GRADE_11}/${SUBJECT_ROUTES.MEDICINE}/:dayNumber/lessons/:numOfLesson`}
            element={<Lesson />}
          />

          {/* Contacts */}
          <Route path={ROUTES.CONTACTS} element={<Contacts />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
